import { BaseModel, IBaseModel } from "../base.model";

export interface IMaintenance extends IBaseModel {
  name?:string;
  description?: string;
  type?:string;
  state?:string;
  method?:string;
  fk_interval_type?:number;
  interval?:number
  alert_pre_delay?:number
  fk_equipment?:number;
  fk_entity_contractor?:number;
  fk_entity_manager_assign?:number;
  fk_attribute?:number;
  fk_template?:number
  use_as_template?:boolean
  last_maintenance_date?:string
  last_maintenance_value?:string|number
}

export class MaintenanceDto extends BaseModel implements IMaintenance {
  name?:string;
  description?: string;
  type?:string;
  state?:string;
  method?:string;
  fk_interval_type?:number;
  interval?:number
  alert_pre_delay?:number
  fk_equipment?:number;
  fk_entity_contractor?:number;
  fk_entity_manager_assign?:number;
  fk_attribute?:number;
  fk_template?:number
  use_as_template?:boolean
  last_maintenance_date?:string
  last_maintenance_value?:string|number

  constructor(opt: IMaintenance) {
    super(opt);
    this.name = opt.name || null
    this.description = opt.description || null
    this.type = opt.type || null
    this.state = opt.state || 'enabled'
    this.method = opt.method || 'auto'
    this.fk_interval_type = opt.fk_interval_type || null
    this.interval = opt.interval || null
    this.alert_pre_delay = opt.alert_pre_delay || null
    this.fk_equipment = opt.fk_equipment || null
    this.fk_entity_contractor = opt.fk_entity_contractor || null
    this.fk_entity_manager_assign = opt.fk_entity_manager_assign || null
    this.fk_attribute = opt.fk_attribute || null
    this.fk_template = opt.fk_template || null
    this.use_as_template = opt.use_as_template || false
    this.last_maintenance_date = opt.last_maintenance_date || new Date().toISOString().substr(0, 10)
    this.last_maintenance_value = opt.last_maintenance_value || null
  }
}



// WEBPACK FOOTER //
// ./src/models/maintenance/maintenance.model.ts